import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

/**
 * The payout report resolver builds its filter controls locally - it issues no server call of its
 * own, so no failure state is ever attached to a response. The member exists so the component's
 * initial-data validation can map an unexpected error envelope the same way its sibling reports do.
 */
export enum PanelReportsReferralPayoutsResolverErrorStatesEnum {
    GetFilterControlsFailed = ErrorStateScheduleEnum.PanelReportsReferralPayoutsResolverErrorStatesStartIndex
}
